/* @flow */

type State = {
  +isConnected: boolean,
  +connectionType: NetInfoConnection,
  +backgroundState: ReactAppState,
  +isInitComplete: boolean,
  +clipboard: {
    +contents: string,
    +hasBeenDismissed: boolean
  }
};

export const INITIAL_STATE = {
  isConnected: false,
  connectionType: 'none',
  backgroundState: 'active',
  isInitComplete: false,
  clipboard: { contents: '', hasBeenDismissed: true },
};

export default (state: State = INITIAL_STATE, action: AnyAction): State => {
  if (action.type === 'CONNECTIVITY_UPDATED') {
    return {
      ...state,
      isConnected: action.payload,
    };
  } if (action.type === 'CONNECTION_UPDATED') {
    return {
      ...state,
      connectionType: action.payload,
    };
  } if (action.type === 'BACKGROUNDSTATE_UPDATED') {
    return {
      ...state,
      backgroundState: action.payload,
    };
  } if (action.type === 'CLIPBOARD_UPDATED') {
    const { contents } = action.payload;
    return {
      ...state,
      clipboard: {
        contents,
        hasBeenDismissed: false,
      },
    };
  } if (action.type === 'CLIPBOARD_DISMISSED') {
    return {
      ...state,
      clipboard: {
        ...state.clipboard,
        hasBeenDismissed: true,
      },
    };
  } if (action.type === 'INIT_COMPLETE') {
    return {
      ...state,
      isInitComplete: true,
    };
  }

  return state;
};
